
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutions/[localeIdentifier]",
      function () {
        return require("private-next-pages/institutions/[localeIdentifier]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutions/[localeIdentifier]"])
      });
    }
  